export default {
	backgroundPermissionRationale_message:
		'To enable {applicationName} to perform geofencing in the background, please grant the {backgroundPermissionOptionLabel} permission',
	backgroundPermissionRationale_negativeAction: 'Cancel',
	backgroundPermissionRationale_positiveAction: 'Change to {backgroundPermissionOptionLabel}',
	backgroundPermissionRationale_title:
		'Do you allow {applicationName} to query the location of the device in the background?',
	location_accept: 'Accept',
	location_app_disclosure: `In the infra-struktur app, the user can activate a geofence feature to use presence management.<br/>
	Necessary authorizations are:<br/>
		- Location<br/>
		- Physical activity<br/>
<br/>
	No data on “Physical activity” is stored on the device or on the server.<br/>
	This is only used to determine the geofence only when the device is moved.<br/>
	No geocoordinates are stored in the app or on the server.<br/>
	The app only transmits the information 0 or 1 to the server when entering or leaving the location defined as a geofence.<br/>
	If the location defined as a geofence is changed administratively, the geofence function is automatically deactivated and must be reactivated by the user`,
	location_deny: 'Deny',
	locationAuthorizationAlert_cancelButton: 'Cancel',
	locationAuthorizationAlert_instructions:
		'So that infra-struktur can also perform geofencing in the background, please grant the location authorization "Always"',
	locationAuthorizationAlert_settingsButton: 'Settings',
	locationAuthorizationAlert_titleWhenNotEnabled: 'The location services are not enabled',
	locationAuthorizationAlert_titleWhenOff: 'The location services are not enabled',
	notification_text: 'Geofencing is active',
	notification_title: 'infra-struktur geofencing',
};
